import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { RootState } from '../reducers';
import { FilterDataTypes, UseFiltersState } from '../types';
import {
  changeSelectedFiltersProperty,
  createSelectedFiltersProperty,
  loadPracticesForDateRangeSelector,
  loadTeams
} from '../actions';
import { FILTER_GLOBAL_KEYS } from '../../config/constants';

/*
 useFiltersState() = {}

 useFiltersState(specificScope) = {...state.filters[specificScope]} // <= preferably not use this case

 useFiltersState(specificScope, filterKey1, filterKey2, ..., filterKeyN) = {
 [FILTER_GLOBAL_KEYS.WEEKS]: {...}, // if filterKeyX === FILTER_GLOBAL_KEYS.WEEKS
 [FILTER_GLOBAL_KEYS.TEAMS]: {nfl: {...}, ncaa: {...}}, // filterKeyX === FILTER_GLOBAL_KEYS.TEAMS
 [filterKey1]: state.filters[specificScope][filterKey1],
 [filterKey2]: state.filters[specificScope][filterKey2],
 ...
 [filterKeyN]: state.filters[specificScope][filterKeyN],
 }
 */

export const useFiltersState = (specificScope: string, ...filterKeys: string[]): UseFiltersState => {
  return useSelector((state: RootState) => {
    if (specificScope && filterKeys.length) {
      const filterData: UseFiltersState = {};
      for (const filterKey of filterKeys) {
        if (filterKey === FILTER_GLOBAL_KEYS.WEEKS) {
          filterData[FILTER_GLOBAL_KEYS.WEEKS] = state.filters[FILTER_GLOBAL_KEYS.WEEKS];
        } else if (filterKey === FILTER_GLOBAL_KEYS.TEAMS) {
          filterData[FILTER_GLOBAL_KEYS.TEAMS] = state.filters[FILTER_GLOBAL_KEYS.TEAMS];
        } else if (filterKey === FILTER_GLOBAL_KEYS.VENUES) {
          filterData[FILTER_GLOBAL_KEYS.VENUES] = state.filters[FILTER_GLOBAL_KEYS.VENUES];
        } else if (filterKey === FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR) {
          filterData[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR] = state.filters[FILTER_GLOBAL_KEYS.PRACTICES_DATE_RANGE_SELECTOR];
        } else {
          filterData[filterKey] = state.filters[specificScope] && state.filters[specificScope][filterKey];
        }
      }
      return filterData;
    }
    if (specificScope) {
      return state.filters[specificScope];
    }
    return {};
  }, shallowEqual);
};

export const useFiltersDispatch = () => {
  const dispatch = useDispatch();
  return {
    changeFilterData: (itemsSelected: FilterDataTypes, filterKey: string, forceScope?: string, otherScopes?: string[]) => () => {
      dispatch(changeSelectedFiltersProperty(itemsSelected, filterKey, forceScope));
      if (otherScopes && otherScopes.length) {
        for (let i = 0; i < otherScopes.length; i++) {
          dispatch(changeSelectedFiltersProperty(itemsSelected, filterKey, otherScopes[i]));
        }
      }
    },
    createFilterData: (itemsSelected: FilterDataTypes, filterKey: string, forceScope?: string) => () => dispatch(createSelectedFiltersProperty(itemsSelected, filterKey, forceScope)),
    loadPracticesForDateRangeSelector: (yearSeason: number, teamId: string, dateRanges: any[]) => () => dispatch(loadPracticesForDateRangeSelector(yearSeason, teamId, dateRanges)),
    loadTeams: () => () => dispatch(loadTeams())
  };
};
